<template>
    <div class="tabs p-5">
      <div class="border rounded-md border-gray-300 shadow-sm pb-2">
        <div class="tab-nav flex justify-between items-center w-full px-5 border-b justify">
          <h2 class="font-bold text-blue-500 text-xl flex items-center py-2.5">
            <button @click="nextTo()" class="pr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
              </svg>
            </button>
            <p v-text="this.user.lastName + ' ' + this.user.firstName"></p>
          </h2>
          <div class="w-40">
            <button
              @click="updatePasswordOrAdd()"
              class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center"
            >
            Save
            </button>
          </div>
        </div>

        <div class="tab-content border-0 px-7">
            <div class="rounded-b-md flex justify-between pt-4">
                <div>
                    <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">NewPassword</label>
                    <input id="password" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите заголовок..." v-model="this.user.password" />
                </div>
                <div>
                    <label for="cpassword" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">ConfPassword</label>
                    <input id="cpassword" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите заголовок..." v-model="this.user.confirmPassword" />
                </div>
            </div>
        </div>
      </div>
      <div v-show="loading">
        <LoadingPage message="Выполняется загрузка ..."></LoadingPage>
      </div>
    </div>
  </template>
  <script>
     import {
        toast
    } from "vue3-toastify";
    import LoadingPage from "./LoadingPage.vue";
  export default {
    beforeRouteLeave(to, from, next) {
      sessionStorage.removeItem("CURRENT_USER");
      next();
    },
    components: {
      LoadingPage
    },
    data() {
      return {
        user: {
          id: "",
          firstName: null,
          lastName: null,
          email: null,
          phoneNumber: null,
          userName: null,
          confirmPassword: null,
          password: null
        },
        loading: true,
        changePasswordUser:
        {
          userId: null,
          newPassword: null,
          confirmPassword: null
        }
        
      };
    },
    methods: {
        nextTo(){
            this.$router.push('/allUser')
        },

        async updatePasswordOrAdd() {
                    this.changePasswordUser.userId = this.user.id;
                    this.changePasswordUser.newPassword = this.user.password;
                    this.changePasswordUser.confirmPassword = this.user.confirmPassword;
            try {
                const response = await this.axios.post(
                    "api/Admin/User/ResetPassword",
                    this.changePasswordUser,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.status === 200) {
                    toast.success("Пароль пользователя: " + this.user.lastName + ' ' + this.user.firstName  + " успешно изменена", {
                        position: "top-center",
                        transition: "flip",
                        newestOnTop: true,
                        toastStyle: {
                            fontSize: "14px",
                        },
                    });
                    this.$router.push('/allUser')
                }
            } catch (error) {
                toast.error("Ошибка при смене пароля пользователя: " + this.user.lastName + ' ' + this.user.firstName, {
                    position: "top-center",
                    transition: "flip",
                    newestOnTop: true,
                    toastStyle: {
                        fontSize: "14px",
                    },
                });
            }
        },
    },
    mounted() {
      if (sessionStorage.getItem("CURRENT_USER")) {
        this.user = JSON.parse(sessionStorage.getItem("CURRENT_USER"));
      }
      this.loading = false;
    },
  };
  </script>